import React from "react";
import { useQuery } from "react-query";
import { getOrderDetail } from "../../api/order";
import { Drawer } from "antd";

const OrderDetail = ({ open, onClose, id }) => {
  const { data } = useQuery("order-detail", () => getOrderDetail(id));
  return (
    <Drawer
      title={
        <div className="flex justify-between">
            <h3>Order Detail</h3>
            <p className={`p-1 rounded-full ${data?.order?.status === "pending" ? "bg-orange-500" : data?.order?.status === "completed" ? "bg-green-600" : "bg-red-400"} capitalize text-white`}>{data?.order?.status}</p>
        </div>        
      }
      closable={{ "aria-label": "Close Button" }}
      onClose={onClose}
      open={open}
    >
      <div className="">
        <h4 className="font-bold text-lg">Customer</h4>
        <div className="flex gap-10">
            <p>First Name:</p>
            <p>{data?.customer?.firstName}</p>
        </div>

        <div className="flex gap-10">
            <p>Last Name:</p>
            <p>{data?.customer?.lastName}</p>
        </div>

        <div className="flex gap-10">
            <p>Email:</p>
            <p className="truncate">{data?.customer?.email}</p>
        </div>

        <div className="flex gap-10">
            <p>Phone Number:</p>
            <p>{data?.customer?.phoneNumber}</p>
        </div>
      </div>

      <div className="mt-10">
        <h4 className="font-bold text-lg">Products</h4>
            <div className="flex justify-between mt-5">
                <p className="font-bold">Title</p>
                <p className="font-bold">Category</p>
                <p className="font-bold">Quantity</p>
                <p className="font-bold">Unit Price</p>
                <p className="font-bold">Total</p>
            </div>
        {(data?.items || []).map(item => (
            <div key={item.product.productId} className="flex justify-between mt-2">
                <p>{item.product.title}</p>
                <p>{item.product.category}</p>
                <p>{item.qty}</p>
                <p>N{Number(item.product.price).toLocaleString()}</p>
                <p>N{Number(item.subtotal).toLocaleString()}</p>
            </div>
        ))}
      </div>
    </Drawer>
  );
};

export default OrderDetail;
